import productCategories from "./productCategories";

export default Object.freeze([
    {
        name: 'All Items',
        value: 'all'
    },
    {
        name: 'Urns & Vessels',
        value: productCategories.urns,
    },
    {
        name: 'Memorabilia',
        value: productCategories.memorialisation,
    },
    {
        name: 'Keepsakes',
        value: productCategories.keepsakes,
    },
]);